export default "__VITE_ASSET__CAC1n8Gd__"